import type { TInlineAlertVariant } from '@reverse-hr/design-system';
import { INLINE_ALERT_VARIANTS } from '@reverse-hr/design-system';
import type {
  FormData,
  TAlertDetail,
} from '@components/ShareLinkModal/ShareLinkModal.types';
import { LANGUAGES } from '@app/models/Common';
import i18n from '@app/i18n';

export const FORM_DEFAULT_VALUES: FormData = {
  clientFirstName: '',
  clientLastName: '',
  clientEmail: '',
  language: '',
};

export const FORM_DEFAULT_TOUCHED: Record<keyof FormData, boolean> = {
  clientFirstName: false,
  clientLastName: false,
  clientEmail: false,
  language: false,
};

export const LANG_OPTIONS = [
  {
    displayValue: i18n.t('modal.share.lang_options.it'),
    optionLabel: i18n.t('modal.share.lang_options.it'),
    value: LANGUAGES.IT,
  },
  {
    displayValue: i18n.t('modal.share.lang_options.en'),
    optionLabel: i18n.t('modal.share.lang_options.en'),
    value: LANGUAGES.EN,
  },
  {
    displayValue: i18n.t('modal.share.lang_options.es'),
    optionLabel: i18n.t('modal.share.lang_options.es'),
    value: LANGUAGES.ES,
  },
  {
    displayValue: i18n.t('modal.share.lang_options.de'),
    optionLabel: i18n.t('modal.share.lang_options.de'),
    value: LANGUAGES.DE,
  },
  {
    displayValue: i18n.t('modal.share.lang_options.fr'),
    optionLabel: i18n.t('modal.share.lang_options.fr'),
    value: LANGUAGES.FR,
  },
];

export const ALERT_VARIANTS_BY_TYPE: Record<
  TAlertDetail['type'],
  TInlineAlertVariant
> = {
  default: INLINE_ALERT_VARIANTS.INFO,
  negative: INLINE_ALERT_VARIANTS.ERROR,
  positive: INLINE_ALERT_VARIANTS.SUCCESS,
  warning: INLINE_ALERT_VARIANTS.WARNING,
};
